import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vaccine-list',
  templateUrl: './vaccine-list.component.html',
  styleUrls: ['./vaccine-list.component.scss']
})
export class VaccineListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
